import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import profilePlaceholder from "../../../../assets/images/logo.png";

const BoardMemberCard = () => {
  return (
    <StyledBoardMemberCard>
      <Helmet>
        <title>Nicolas Marais - Co-Founder &amp; Business Leader | NexTech PLM Solutions</title>
        <meta name="description" content="Profile of Nicolas Marais, Co-Founder and business leader at NexTech PLM Solutions with 20 years of PLM, ALM, CAD expertise and executive management in Siemens partner companies." />
        <meta name="keywords" content="Nicolas Marais NexTech PLM, PLM co-founder business leader, ALM CAD expert, Siemens partner executive, PLM software delivery leader" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/about/board-of-directors/nicolas-marais" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="profile" />
        <meta property="og:title" content="Nicolas Marais - Co-Founder & Business Leader | NexTech PLM Solutions" />
        <meta property="og:description" content="Profile of Nicolas Marais, Co-Founder and business leader at NexTech PLM Solutions with 20 years of PLM, ALM, CAD expertise." />
        <meta property="og:url" content="https://nextechplm.com/about/board-of-directors/nicolas-marais" />
        <meta property="og:image" content="https://nextechplm.com/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Nicolas Marais - Co-Founder & Business Leader | NexTech PLM Solutions" />
        <meta name="twitter:description" content="Profile of Nicolas Marais, Co-Founder and business leader at NexTech PLM Solutions with 20 years of PLM, ALM, CAD expertise." />
        <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
      </Helmet>
      <Container>
        <h1>Nicolas Marais</h1>
        <h5>Founder, Chairman and Managing Director</h5>
        <Content>
          <LeftSide>
            <ProfileImage
              src={profilePlaceholder}
              alt="Nicolas Marais"
            />
            <IconSocial>
              <a
                href="https://www.linkedin.com/in/nicolas-marais-121b028b/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-linkedin bg-linkedin"></i>
              </a>
              {/* Replace with Twitter link */}
              <span aria-label="X profile unavailable" role="img">
                <i className="fa-brands fa-x-twitter bg-twitter"></i>
              </span>
            </IconSocial>
          </LeftSide>
          <RightSide>
            <p>
              Nicolas is a distinguished professional with 20 years of
              experience in the PLM, ALM, and CAD domains, leading Siemens
              partner companies. His career includes over 10 years of executive
              management, during which he has honed his leadership and strategic
              planning skills.
            </p>
            <p>
              Nicolas excels in translating business needs from operations into
              actionable requirements and managing multiple concurrent
              development projects under intense pressure. His ability to
              balance technical and business perspectives ensures the successful
              delivery of complex projects.
            </p>
            <p>
              In addition to his role at NexTech, Nicolas is the Managing
              Director of EB Solutions, a company specializing in software
              development in the PLM field. He also serves as a Board Member of
              IT Development, which focuses on software development in the
              telecom sector. His multifaceted expertise and leadership roles
              across different organizations highlight his commitment to driving
              innovation and excellence in the software development industry.
            </p>
          </RightSide>
        </Content>
      </Container>
    </StyledBoardMemberCard>
  );
};

export default BoardMemberCard;

// Styled Components
const StyledBoardMemberCard = styled.section`
  padding: 1rem 2rem;
  border-radius: 10px;
  max-width: 900px;
  margin: 2rem auto;
`;

const Container = styled.div`
  h1 {
    font-size: 3.1rem;
    font-family: "Space Grotesk", sans-serif;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #07b6f2;
  }

  h5 {
    font-size: 1.3rem;
    font-family: "Jost", sans-serif;
    font-weight: normal;
    margin-bottom: 1.5rem;
    color: #777;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }

    h5 {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 2em;
      text-align: center;
    }
    h5 {
      font-size: 1em;
      text-align: center;
    }
  }

`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 2rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 2rem;
  }
`;

const ProfileImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 1rem;
`;

const IconSocial = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  a {
    margin: 0 0.5rem;
    font-size: 1.5rem;
    color: #000;
    transition: color 0.3s;

    &:hover {
      color: #0077b5; /* LinkedIn color */
    }
  }

  .bg-linkedin {
    color: #0077b5;
  }
  .bg-twitter {
    color: #555;
  }
`;

const RightSide = styled.div`
  flex: 1;

  p {
    font-size: 1.2rem;
    font-family: "Jost", sans-serif;
    color: #777777;
    line-height: 2;
    text-align: justify;
  }

  @media (max-width: 768px) {
    p {
      text-align: justify;
    }
  }

  @media (max-width: 480px) {
    p {
      font-size: 1em;
    }
  }
`;
